import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/clients/')({
  component: ClientsPage,
})

function ClientsPage(): JSX.Element {
  return <div>Clientes — placeholder</div>
}
